import { useState } from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton
} from '@mui/material'
import TextLabel from '../../../../../components/form/TextLabel/TextLabel'
import { countries } from '../../../../../utils/phone'
import css from './DatosTelefono.module.css'

const DatosTelefono = ({ alumno, onEdit }) => {
  const [isExpanded, setExpanded] = useState(true)

  const handleChange = (_event, isExpanded) => {
    setExpanded(isExpanded)
  }

  const handleEdit = e => {
    e.stopPropagation()
    onEdit()
  }

  const telefonos = alumno.telefonos || []

  const getCountryDisplay = prefix => {
    if (!prefix) return '-'
    const country = countries.find(c => c.callingCode === prefix)
    return country ? `${country.emoji} ${prefix}` : prefix
  }

  return (
    <Accordion expanded={isExpanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
      >
        <div className={css.label}>
          <Typography className={css.title} variant='h2'>
            Datos de teléfono
          </Typography>
          {isExpanded && (
            <IconButton
              className={css.button}
              size='small'
              color='secondary'
              onClick={handleEdit}
            >
              <i className='material-icons'>edit</i>
            </IconButton>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails className={css.details}>
        {telefonos.length === 0 ? (
          <div className={css.emptyState}>
            <Typography variant='body2' color='textSecondary'>
              No hay teléfonos registrados
            </Typography>
          </div>
        ) : (
          <div className={css.telefonosContainer}>
            {telefonos.map((telefono, index) => (
              <div key={index} className={css.telefonoRow}>
                <TextLabel
                  className={css.field}
                  name={`contacto-${index}`}
                  label='Contacto'
                  value={telefono.nombre || '-'}
                />
                <div className={css.phoneFields}>
                  <TextLabel
                    className={css.countryField}
                    name={`flag-${index}`}
                    label='Prefijo'
                    value={getCountryDisplay(telefono.prefijoInternacional)}
                  />
                  <TextLabel
                    className={css.field}
                    name={`telefono-${index}`}
                    label='Teléfono'
                    value={telefono.telefono}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  )
}

export default DatosTelefono
